module.exports = __webpack_public_path__ + "static/media/privacy_legal.9764097f.svg";